export const SocketEventType = {
  ASSET_LIQUIDATION_UPDATED_SOCKET_EVENT: 'AssetLiquidationUpdatedSocketEvent',
  ASYNC_REQUEST_JOB_COMPLETE_SOCKET_EVENT: 'AsyncRequestJobCompleteSocketEvent',
  CONENT_SOURCE_UPDATED_SOCKET_EVENT: 'ContentSourceUpdatedSocketEvent',
  SAVE_CONVERSATION_USER_SOCKET_EVENT: 'SaveConversationUserSocketEvent',
  CONVERSATION_CLARA_DRAFTING_CHANGED_USER_SOCKET_EVENT:
    'ConversationClaraDraftingChangedUserSocketEvent',
  DOCUMENT_EXTRACTED_USER_SOCKET_EVENT: 'DocumentExtractedUserSocketEvent',
  ESIGN_ENVELOPE_STATUS_UPDATE_ESTATE_SOCKET_EVENT: 'EsignEnvelopeStatusUpdateEstateSocketEvent',
  FINANCIAL_ACCOUNT_TRANSACTIONS_RECONCILED_SOCKET_EVENT:
    'FinancialAccountTransactionsReconciledSocketEvent',
  FINANCIAL_GATEWAY_LOGIN_REQUIRED_PUBLIC_SOCKET_EVENT:
    'FinancialGatewayLoginRequiredPublicSocketEvent',
  FINANCIAL_GATEWAY_ESTATE_BANKING_ACCOUNT_CREATED_SOCKET_EVENT:
    'FinancialGatewayEstateBankingAccountCreatedSocketEvent',
  FINANCIAL_GATEWAY_FLINKS_DOWNLOAD_ACCOUNTS_DOWNLOADED_SOCKET_EVENT:
    'FinancialGatewayFlinksDownloadAccountsDownloadedSocketEvent',
  FINANCIAL_ACCOUNT_FLINKS_BANKING_BALANCES_UPDATED_SOCKET_EVENT:
    'FinancialAccountFlinksBankingBalancesUpdatedSocketEvent',
  FINANCIAL_ACCOUNT_FLINKS_INVESTMENT_BALANCES_UPDATED_SOCKET_EVENT:
    'FinancialAccountFlinksInvestmentBalancesUpdatedSocketEvent',
  LIABILITY_DEBT_REPAYMENT_UPDATED_SOCKET_EVENT: 'LiabilityDebtRepaymentUpdatedSocketEvent',
  MESSAGE_CLARA_DRAFT_CHANGED_USER_SOCKET_EVENT: 'MessageClaraDraftChangedUserSocketEvent',
  MESSAGE_CONVERSATION_SOCKET_EVENT: 'MessageConversationSocketEvent',
  NEW_MESSAGE_USER_SOCKET_EVENT: 'NewMessageUserSocketEvent',
  NOTIFY_USER_SOCKET_EVENT: 'NotifyUserSocketEvent',
  REFERRAL_COMPLETED_SOCKET_EVENT: 'ReferralCompletedSocketEvent',
  REMOVE_CONVERSATION_USER_SOCKET_EVENT: 'RemoveConversationUserSocketEvent',
  USER_EMAIL_VERIFICATION_USER_SOCKET_EVENT: 'UserEmailVerificationUserSocketEvent',
  OCR_GENERATED_USER_SOCKET_EVENT: 'OcrGeneratedUserSocketEvent',
  ESTATE_SUMMARY_GENERATED_ESTATE_SOCKET_EVENT: 'EstateSummaryGeneratedEstateSocketEvent',
  ESTATE_SUMMARY_GENERATION_FAILED_ESTATE_SOCKET_EVENT:
    'EstateSummaryGenerationFailedEstateSocketEvent',
  DOCUMENT_ANALYSIS_COMPLETED_ESTATE_SOCKET_EVENT: 'DocumentAnalysisCompletedEstateSocketEvent'
};
